import React from "react";
import { lePetitPrinceImages } from "../../../../../../Assets/images/le-petit-prince";
import StyledDiv from "../../../../../StyledDiv/StyledDiv";
import { IStyledDivStyles } from "../../../../../StyledDiv/StyledDiv";

interface IGlobeYellowSingleBigProps {
  styles?: IStyledDivStyles;
}

const GlobeYellowSingleBig = ({ styles }: IGlobeYellowSingleBigProps) => {
  return (
    <StyledDiv styles={styles} className="globe-yellow-single-big">
      <img
        src={lePetitPrinceImages.globeYellowSingleBig}
        alt="Yellow globe single big"
        style={{ width: "auto", height: "auto" }}
      />
    </StyledDiv>
  );
};

export default GlobeYellowSingleBig;
